module.exports = __webpack_public_path__ + "static/media/sgs.6a803686.png";